"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySet = void 0;
const util_1 = require("./util");
/** Tracks a set of actively pressed keys. */
class KeySet {
    constructor(keys = []) {
        this.keys = keys;
    }
    add(key) {
        this.remove(key);
        this.keys.push(key);
    }
    remove(key) {
        const keys = this.keys;
        const index = keys.findIndex((k) => k.key === key.key);
        if (index !== -1)
            keys.splice(index, 1);
    }
    reset() {
        this.keys = [];
    }
    /** Removes all non-modifier keys, keeping Meta, Control, Alt, Shift. */
    clearNonMods() {
        this.keys = this.keys.filter((k) => (0, util_1.isMod)(k.key));
    }
    start() {
        const keys = this.keys;
        if (keys.length === 0)
            return 0;
        return Math.min(...keys.map((k) => k.ts));
    }
    end() {
        const keys = this.keys;
        if (keys.length === 0)
            return 0;
        return Math.max(...keys.map((k) => k.ts));
    }
    /**
     * Builds the canonical chord signature for the current pressed set,
     * e.g. `'Control+a+b'` when Ctrl+A and Ctrl+B are both held.
     *
     * - Key names are normalized the same way `Key.sig()` does it and then
     *   sorted alphabetically.
     * - Modifier keys (Alt, Control, Meta, Shift) are excluded from the
     *   chord key list since they're already represented in the mod prefix.
     * - The shared modifier prefix is taken from the first key in insertion order.
     *   All chord keys are expected to share the same modifier state.
     */
    sig() {
        const normalized = this.keys
            .filter((k) => !(0, util_1.isMod)(k.key))
            .map((k) => (k.key === ' ' ? 'Space' : k.key.length === 1 ? k.key.toLowerCase() : k.key))
            .sort();
        const mod = this.keys[0]?.mod ?? '';
        if (!normalized.length)
            return mod;
        return mod ? `${mod}+${normalized.join('+')}` : normalized.join('+');
    }
    /** ----------------------------------------------------- {@link Printable} */
    toString(tab) {
        return `pressed { ${this.keys.map((k) => k.sig()).join(', ')} }`;
    }
}
exports.KeySet = KeySet;
